import { MockHook, PermissionType } from '@jupiterone/jupiter-web-toolkit';
export interface PermissionListItemProps {
  permissionSetKey: string;
  permissionSetValues: any;
}

const usePermissionListItemLogic = ({
  permissionSetKey,
  permissionSetValues,
}: PermissionListItemProps) => {
  const permissionKey = permissionSetKey;
  const isValueArray = Array.isArray(permissionSetValues);
  const permissionValue: string = isValueArray
    ? permissionSetValues.join(', ')
    : permissionSetValues.toString();
  const instanceIds: false | string[] =
    permissionKey === PermissionType.integrationInstanceId &&
    isValueArray &&
    permissionSetValues;

  return {
    permissionKey,
    permissionValue,
    instanceIds,
  };
};

export type PermissionListItemComponentProps = ReturnType<
  typeof usePermissionListItemLogic
>;
export const MOCK_PERMISSION_LIST_ITEM_PROPS: PermissionListItemComponentProps = {
  permissionKey: '_key',
  permissionValue: 'val1, val2',
  instanceIds: false,
};
export default MockHook.useMockHook(
  usePermissionListItemLogic,
  MOCK_PERMISSION_LIST_ITEM_PROPS
);
